import styled from 'styled-components'
import { Mono, theme } from '@superhi/design'

export const Blockquote = styled.div`
  display: block;
`

export const Code = styled(Mono).attrs({ forwardedAs: 'code' })`
  display: inline-block;
  background-color: ${theme.colors.PALE_BLUE_40};
  padding: 0.1em 0.2em;
  margin: -0.1em;
`

export const Wrapper = styled.div`
  > h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &:not(:first-child) {
      margin-top: 40px;
    }
    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  > ul,
  > ol {
    padding: 0 0 0 1em;

    &:not(:first-child) {
      margin-top: 40px;
    }
    &:not(:last-child) {
      margin-bottom: 40px;
    }

    li:not(:last-child) {
      margin-bottom: 0.5em;
    }
  }

  > ${Blockquote} {
    &:not(:first-child) {
      margin-top: 40px;
    }
    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }
`
